import WorkflowBuilder from "./workflow";
import SoftwareAgGridHook from './software/SoftwareAgGridHook'
import CoreTransactionAgGridHook from './settlement/CoreTransactionAgGridHook'
import DashboardChartHook from './settlement/DashboardChartHook'
import PosSettlementAgGridHook from './settlement/PosSettlementAgGridHook'
import QrSettlementAgGridHook from './settlement/QrSettlementAgGridHook'
import MisApprovalAgGridHook from './settlement/MisApprovalAgGridHook'
import MisItemsAgGridHook from './settlement/MisItemsAgGridHook'
import TidMasterAgGridHook from './settlement/TidMasterAgGridHook'
import BinRangeAgGridHook from './scheme/BinRangeAgGridHook'
import TerminalAgGridHook from './terminal/TerminalAgGridHook'
import ParameterLogsAgGridHook from './parameter/ParameterLogsAgGridHook'
import AppPackagesAgGridHook from './ota/AppPackagesAgGridHook'
import AppUpgradeJobsAgGridHook from './ota/AppUpgradeJobsAgGridHook'
import AppUpgradeStatusesAgGridHook from './ota/AppUpgradeStatusesAgGridHook'
import VersionComplianceAgGridHook from './compliance/VersionComplianceAgGridHook'
import TerminalDashboardAgGridHook from './terminal/TerminalDashboardAgGridHook'
import UpdateStatsChartHook from './terminal/UpdateStatsChartHook'
import OnlineRateGaugeHook from './terminal/OnlineRateGaugeHook'
import { TerminalLocationMapHook } from './terminal/TerminalLocationMapHook'
import { AnalyticsGeographicMapHook } from './analytics/AnalyticsGeographicMapHook'
import { TerminalLocationsMapHook } from './terminal/TerminalLocationsMapHook'
import { RemoteControlHook, LogViewerHook } from './terminal/RemoteControlHook'
import ScreenShareHook from './terminal/ScreenShareHook'
import ScreenShareCanvasHook from './terminal/ScreenShareCanvasHook'
import AgentIncidentAgGridHook from './agents/AgentIncidentAgGridHook'
import ChargebackDashboardAgGridHook from './chargeback/ChargebackDashboardAgGridHook'
import MerchantScreeningAgGridHook from './merchant/MerchantScreeningAgGridHook'
import MerchantOnboardingAgGridHook from './merchant/MerchantOnboardingAgGridHook'
import GroupsAgGridHook from './merchant/GroupsAgGridHook'
import HierarchyAgGridHook from './merchant/HierarchyAgGridHook'
import RiskLedgerMerchantPickerAgGridHook from './merchant/RiskLedgerMerchantPickerAgGridHook'
import RiskDashboardAgGridHook from './risk/RiskDashboardAgGridHook'
import RiskRulesAgGridHook from './risk/RiskRulesAgGridHook'
import PoliciesIndexAgGridHook from './risk/PoliciesIndexAgGridHook'
import PolicyTriggersAgGridHook from './risk/PolicyTriggersAgGridHook'
import ReportsAgGridHook from './reports/ReportsAgGridHook'
import ReportsChartHook from './reports/ReportsChartHook'
import ModuleDock from './navigation/ModuleDockHook'
import NavSidebar from './navigation/NavSidebarHook'
import AutoHideHeader from './navigation/AutoHideHeaderHook'
import ThemeToggle from './navigation/ThemeHook'
import ExternalFrame from './observability/ExternalFrameHook'

let Hooks = {}

Hooks.Focus = {
  mounted() {
    this.el.focus()
  }
}

// Keeps a scrollable chat transcript pinned to the latest message —
// without this, new turns render below the fold of the container's own
// scroll (the page/viewport scrolls fine, but the inner overflow-y-auto
// region does not follow new content on its own).
Hooks.ScrollToBottom = {
  mounted() {
    this.scrollToBottom()
  },
  updated() {
    this.scrollToBottom()
  },
  scrollToBottom() {
    this.el.scrollTop = this.el.scrollHeight
  }
}

// Debug hook for form submissions
Hooks.FormDebug = {
  mounted() {
    this.el.addEventListener('submit', (e) => {
      console.log('Form submission detected:', e.target);
      console.log('Form data:', new FormData(e.target));
      
      // Log all form data
      const formData = new FormData(e.target);
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
    });
  }
}

Hooks.SoftwareAgGrid = SoftwareAgGridHook
Hooks.WorkflowBuilder = WorkflowBuilder;
Hooks.CoreTransactionAgGridHook = CoreTransactionAgGridHook;
Hooks.DashboardChartHook = DashboardChartHook;
Hooks.PosSettlementAgGridHook = PosSettlementAgGridHook;
Hooks.QrSettlementAgGridHook = QrSettlementAgGridHook;
Hooks.MisApprovalAgGridHook = MisApprovalAgGridHook;
Hooks.MisItemsAgGridHook = MisItemsAgGridHook;
Hooks.TidMasterAgGridHook = TidMasterAgGridHook;
Hooks.BinRangeAgGridHook = BinRangeAgGridHook;
Hooks.TerminalAgGridHook = TerminalAgGridHook;
Hooks.ParameterLogsAgGridHook = ParameterLogsAgGridHook;
Hooks.AppPackagesAgGridHook = AppPackagesAgGridHook;
Hooks.AppUpgradeJobsAgGridHook = AppUpgradeJobsAgGridHook;
Hooks.AppUpgradeStatusesAgGridHook = AppUpgradeStatusesAgGridHook;
Hooks.VersionComplianceAgGridHook = VersionComplianceAgGridHook;
Hooks.AgentIncidentAgGridHook = AgentIncidentAgGridHook;
Hooks.ChargebackDashboardAgGridHook = ChargebackDashboardAgGridHook;
Hooks.MerchantScreeningAgGridHook = MerchantScreeningAgGridHook;
Hooks.MerchantOnboardingAgGridHook = MerchantOnboardingAgGridHook;
Hooks.GroupsAgGridHook = GroupsAgGridHook;
Hooks.HierarchyAgGridHook = HierarchyAgGridHook;
Hooks.RiskLedgerMerchantPickerAgGridHook = RiskLedgerMerchantPickerAgGridHook;
Hooks.RiskDashboardAgGridHook = RiskDashboardAgGridHook;
Hooks.RiskRulesAgGridHook = RiskRulesAgGridHook;
Hooks.PoliciesIndexAgGridHook = PoliciesIndexAgGridHook;
Hooks.PolicyTriggersAgGridHook = PolicyTriggersAgGridHook;

// Platform navigation (docs/Menus-Management/menu-design.md)
Hooks.ModuleDock = ModuleDock;
Hooks.NavSidebar = NavSidebar;
Hooks.AutoHideHeader = AutoHideHeader;
Hooks.ThemeToggle = ThemeToggle;
Hooks.ExternalFrame = ExternalFrame;
Hooks.TerminalDashboardAgGridHook = TerminalDashboardAgGridHook;
Hooks.UpdateStatsChartHook = UpdateStatsChartHook;
Hooks.OnlineRateGaugeHook = OnlineRateGaugeHook;
Hooks.TerminalLocationMapHook = TerminalLocationMapHook;
Hooks.AnalyticsGeographicMapHook = AnalyticsGeographicMapHook;
Hooks.TerminalLocationsMapHook = TerminalLocationsMapHook;
Hooks.RemoteControl = RemoteControlHook;
Hooks.LogViewer = LogViewerHook;
Hooks.ScreenShare = ScreenShareHook;
Hooks.ScreenShareCanvas = ScreenShareCanvasHook;

// CSV Download Hook - handles server-pushed CSV download events
Hooks.CSVDownload = {
  mounted() {
    this.handleDownload = (e) => {
      const {filename, content} = e.detail;
      const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
    
    // Listen to Phoenix LiveView push_event broadcasts
    window.addEventListener("phx:download_csv", this.handleDownload);
  },
  
  destroyed() {
    // Clean up event listener when hook is removed
    if (this.handleDownload) {
      window.removeEventListener("phx:download_csv", this.handleDownload);
    }
  }
}

// File Download Hook - handles generic file downloads from LiveView
Hooks.FileDownload = {
  mounted() {
    this.handleDownload = (e) => {
      const {filename, content, type} = e.detail;
      const blob = new Blob([content], { type: type || 'text/csv;charset=utf-8;' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
    
    // Listen to Phoenix LiveView push_event broadcasts
    window.addEventListener("phx:download_file", this.handleDownload);
  },
  
  destroyed() {
    // Clean up event listener when hook is removed
    if (this.handleDownload) {
      window.removeEventListener("phx:download_file", this.handleDownload);
    }
  }
}

// Audit & Compliance export — the LiveView generates a stored, checksummed
// report artifact and then pushes its download URL here, rather than streaming
// bytes over the socket. Going through a normal HTTP GET means the download is
// authenticated and authorised by the router like any other request, and the
// artifact stays retrievable from the Reports tab afterwards.
Hooks.AuditDownload = {
  mounted() {
    this.handleOpen = (e) => {
      const {url} = e.detail;
      if (!url) return;
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    window.addEventListener("phx:open_download", this.handleOpen);
  },

  destroyed() {
    if (this.handleOpen) {
      window.removeEventListener("phx:open_download", this.handleOpen);
    }
  }
}

// File Upload Click Hook - handles click-to-upload for file inputs
Hooks.FileUploadClick = {
  mounted() {
    this.el.addEventListener('click', (e) => {
      // Find the form containing this element
      const form = this.el.closest('form');
      if (form) {
        // Find the file input within the form
        const fileInput = form.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    });
  }
}

Hooks.ReportsAgGrid = ReportsAgGridHook
Hooks.ReportsChart = ReportsChartHook

export {Hooks}
